'use client';

import { TourGuide } from '@insta-club/models';
import { CustomVideo, ReelsDescription } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import { memo, useState } from 'react';

const TourGuideVideo: React.FC<{
    item: TourGuide | null;
    onTimeupdateDelay?: (time: number) => void;
    onBack: () => void;
}> = ({ item, onTimeupdateDelay, onBack }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className='relative h-full w-full cursor-pointer bg-black'>
            <div
                onClick={() => setExpanded(false)}
                className={cn('absolute inset-x-0 bottom-0 z-30 bg-gradient-to-t from-black to-transparent', {
                    'pointer-events-auto top-0': expanded,
                    'pointer-events-none h-1/3': !expanded
                })}
            />

            <MemoizedTourGuideVideoContent item={item} onTimeupdateDelay={onTimeupdateDelay} onBack={onBack} />

            <div className='absolute inset-x-0 bottom-8 z-50 flex flex-col gap-2 px-4 text-white'>
                {item?.title ? (
                    <ReelsDescription text={item.title} isExpanded={expanded} onExpanded={setExpanded} />
                ) : null}
            </div>
        </div>
    );
};

export default TourGuideVideo;

interface VideoContentProps {
    item: TourGuide | null;
    onTimeupdateDelay?: (time: number) => void;
    onBack: () => void;
}

const TourGuideVideoContent: React.FC<VideoContentProps> = ({ item, onTimeupdateDelay, onBack }) => {
    if (item?.url) {
        return (
            <CustomVideo
                hlsUrl={item.hls}
                mp4Url={item.url}
                disableProgress={false}
                showProgress
                loop={false}
                showEndDialog={true}
                autoPlayPaused
                onTimeupdateDelay={onTimeupdateDelay}
                onBack={onBack}
            />
        );
    }

    return null;
};

const MemoizedTourGuideVideoContent = memo(TourGuideVideoContent);

